import { FC } from 'react';

type HeaderInfoProps = {
  studyName: string;
  site: string;
  subject: string;
  visit: string;
};

export const HeaderInfo: FC<HeaderInfoProps> = ({
  studyName,
  site,
  subject,
  visit,
}) => {
  const items = [
    { label: 'Study:', value: studyName },
    { label: 'Site:', value: site },
    { label: 'Subject:', value: subject },
    { label: 'Visit:', value: visit },
  ];

  return (
    <div>
      <h2 className='p-1.5 text-1824 font-medium bg-body rounded-[8px] mt-0 mb-3'>
        General Information
      </h2>
      <div className={'flex ps-1.5'}>
        {items.map(({ label, value }, idx) => (
          <div
            key={label}
            className={'flex text-1824 font-medium text-chineseBlack'}
          >
            <span className={'text-dimGray text-1624 mr-1'}>{label}</span>
            {value}
            {idx !== items.length - 1 && (
              <div className={'h-3 bg-pastelBlue w-[1px] mx-3'}></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
